<template>
    <div>
        <!-- FASE 4 / BLOCO AD — DOC 62, 65, 74, 75, 87 -->

        <el-row class="u-mt-10 u-mb-15">
            <el-col :xs="24" :sm="16">
                <el-alert type="warning" :closable="false" show-icon
                          title="O certificado fica guardado em área privada, e a senha é cifrada."
                          description="Certificado e-CPF é pessoal: só o titular assina com ele. Certificado da entidade (e-CNPJ) é mantido pela rede e pode ser compartilhado.">
                </el-alert>
            </el-col>
            <el-col :xs="24" :sm="8" class="u-text-right">
                <el-button type="primary" icon="el-icon-upload2" @click="dialogImportar = true">
                    CADASTRAR CERTIFICADO
                </el-button>
            </el-col>
        </el-row>

        <div class="container-table" v-loading="!statusList">
            <table class="table table-striped">
                <thead>
                    <tr><th>Nome</th><th class="hidden-mobile">Titular</th>
                        <th class="hidden-mobile">Emissor</th>
                        <th class="u-text-center" style="width:120px">Validade</th>
                        <th class="u-text-center" style="width:300px">Tipo</th>
                        <th class="u-text-center" style="width:150px">Ação</th></tr>
                </thead>
                <tbody>
                    <tr v-for="c in items" :key="c.id" :class="{ vencido: venceu(c) }">
                        <td>{{ c.nome }}</td>
                        <td class="hidden-mobile meta">{{ c.cn || '—' }}</td>
                        <td class="hidden-mobile meta">{{ c.emissor || '—' }}</td>
                        <td class="u-text-center">
                            <span :class="venceu(c) ? 'txt-vencido' : ''">{{ c.valido_ate | data }}</span>
                        </td>
                        <td class="u-text-center">
                            <el-tag size="mini" :type="c.titular_tipo === 'instituicao' ? 'warning' : 'info'">
                                {{ c.titular_tipo === 'instituicao' ? 'entidade' : 'pessoal' }}
                            </el-tag>
                            <el-tag v-if="c.compartilhado" size="mini" type="success">compartilhado</el-tag>
                        </td>
                        <td class="u-text-center acao">
                            <!-- DOC 74 -->
                            <el-button v-if="c.titular_tipo === 'instituicao'" size="mini" plain
                                       :type="c.compartilhado ? 'warning' : 'success'"
                                       :title="c.compartilhado ? 'Deixar de compartilhar' : 'Compartilhar'"
                                       icon="el-icon-share" @click="compartilhar(c)"></el-button>
                            <el-button class="u-ml-10" size="mini" plain :type="c.ativo ? 'info' : 'success'"
                                       :icon="c.ativo ? 'el-icon-turn-off' : 'el-icon-open'"
                                       :title="c.ativo ? 'Desativar' : 'Ativar'"
                                       @click="definirAtivo(c)"></el-button>
                            <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                       title="Excluir" @click="excluir(c)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length && statusList">
                        <td colspan="6" class="u-text-center u-mt-25">Nenhum certificado cadastrado.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <el-dialog title="Cadastrar certificado digital" :visible.sync="dialogImportar" width="560px">
            <el-form label-position="top" class="u-mt-10">

                <el-row :gutter="10">
                    <el-form-item label="Arquivo do certificado (.pfx ou .p12)">
                        <el-upload class="u-mt-10" action="" :auto-upload="false" :limit="1"
                                :on-change="aoEscolher" :on-remove="() => arquivo = null"
                                accept=".pfx,.p12">
                            <el-button icon="el-icon-paperclip">SELECIONAR ARQUIVO</el-button>
                        </el-upload>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="Senha do certificado">
                        <el-input v-model="form.senha" type="password" show-password></el-input>
                        <div class="meta">
                            A senha é guardada cifrada e usada apenas no momento de assinar.
                        </div>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="Nome para identificar">
                        <el-input v-model="form.nome" maxlength="150"
                                placeholder="Ex.: e-CPF da diretora"></el-input>
                    </el-form-item>
                </el-row>
                <!--
                    O certificado é gravado sempre vinculado a uma instituição, e perfil de
                    rede não tem escola no contexto do header: sem este campo o `importar`
                    respondia 403 "Informe a instituição", sem onde informá-la.
                -->
                <el-row :gutter="10">
                    <el-form-item label="Instituição" v-if="ehRede">
                        <el-select v-model="form.instituicao_id" filterable clearable
                                placeholder="Selecione a instituição" style="width:100%">
                            <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item v-if="podeEntidade">
                        <el-checkbox v-model="form.entidade">
                            É certificado da entidade (e-CNPJ)
                        </el-checkbox>
                        <el-checkbox v-if="form.entidade" v-model="form.compartilhado">
                            Permitir que outros usuários assinem com ele
                        </el-checkbox>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogImportar = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!arquivo || !form.senha" @click="importar">
                    CADASTRAR
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        data (v) { return v ? moment(v).format('DD/MM/YYYY') : '—' }
    },
    data: () => ({
        statusList: false,
        items: [],
        dialogImportar: false,
        arquivo: null,
        form: { senha: '', nome: '', entidade: false, compartilhado: false, instituicao_id: null },
        instituicoes: []
    }),
    computed: {
        /** Perfis de abrangência de rede — os que não têm escola no contexto do header. */
        ehRede () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        },
        /** Espelha CertificadoDigitalService::PERFIS_ENTIDADE — precisam continuar iguais. */
        podeEntidade () {
            const t = Number(this.$store.state.user ? this.$store.state.user.tipo : -1)
            return t === 4 || t === 5 || t === 6
        }
    },
    mounted () {
        this.carregar()
        if (this.ehRede) this.carregarInstituicoes()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        carregarInstituicoes () {
            this.$axios.get(`${this.base()}/api/instituicao/getAll`, this.auth())
                .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : Object.values(r.data || {}) })
                .catch(() => { this.instituicoes = [] })
        },

        instituicaoAtual () {
            if (this.form.instituicao_id) return this.form.instituicao_id
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        venceu (c) { return c.valido_ate && moment(c.valido_ate).isBefore(moment()) },

        carregar () {
            this.statusList = false
            this.$axios.post(`${this.base()}/api/certificado-digital/getAllPaginate`, {}, this.auth())
                .then(r => { this.items = r.data.data; this.statusList = true })
                .catch(e => { this.statusList = true; this.erro(e) })
        },

        aoEscolher (file) { this.arquivo = file.raw },

        importar () {
            if (!this.instituicaoAtual()) {
                return window.eventBus.$emit('alert', {
                    msg: 'Selecione a instituição antes de cadastrar o certificado.', type: 'warning'
                })
            }

            const form = new FormData()
            form.append('arquivo', this.arquivo)
            form.append('senha', this.form.senha)
            form.append('nome', this.form.nome)
            form.append('instituicao_id', this.instituicaoAtual())
            form.append('titular_tipo', this.form.entidade ? 'instituicao' : 'usuario')
            if (this.form.entidade && this.form.compartilhado) form.append('compartilhado', '1')

            const cfg = Object.assign({}, this.auth())
            cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.base()}/api/certificado-digital/importar`, form, cfg).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Certificado cadastrado.', type: 'success' })
                this.dialogImportar = false
                this.arquivo = null
                this.form = { senha: '', nome: '', entidade: false, compartilhado: false, instituicao_id: null }
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        compartilhar (c) {
            this.$axios.post(`${this.base()}/api/certificado-digital/compartilhar/${c.id}`,
                { compartilhado: !c.compartilhado }, this.auth()).then(() => {
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        definirAtivo (c) {
            this.$axios.post(`${this.base()}/api/certificado-digital/definir-ativo/${c.id}`,
                { ativo: !c.ativo }, this.auth()).then(() => {
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        excluir (c) {
            this.$msgbox.confirm(
                'Excluir este certificado? Se ele já assinou documentos, será apenas desativado.',
                'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/certificado-digital/remover/${c.id}`, this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', {
                            msg: r.data.inativado ? r.data.mensagem : 'Sucesso! - Certificado excluído.',
                            type: 'success'
                        })
                        this.carregar()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        }
    }
}
</script>
<style scoped>
.meta        { font-size: 12px; color: #909399; }
.vencido     { background: #fef0f0 !important; }
.txt-vencido { color: #F56C6C; font-weight: 600; }
</style>
